import { Ticket } from './DtoTicket';

export interface ITicketQuantity {
    ticket: Ticket;
    quantity: number;
    checked: boolean;
    locked: boolean;
}

export class TicketQuantity implements ITicketQuantity {
    ticket!: Ticket;
    quantity!: number;
    checked!: boolean;
    locked!: boolean;

    constructor(ticketQuantity: ITicketQuantity) {
        this.ticket = ticketQuantity.ticket;
        this.quantity = ticketQuantity.quantity;
        this.checked = ticketQuantity.checked;
        this.locked = ticketQuantity.locked;
    }

    get ticketPrice() {
        return this.ticket.calculatePrice(this.quantity > 1 ? this.quantity : 1);
    }

    get ticketSubtotal() {
        return this.ticket.calculateSubtotal(this.quantity);
    }

    unlockTicket() {
        if (this.locked) {
            this.locked = false;
            this.quantity = 0;
            this.checked = false;
        }
    }

    lockTicket() {
        if (!this.locked) {
            this.locked = true;
            this.quantity = 0;
            this.checked = false;
        }
    }
}
